<template>
  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>操作表单</span>
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus">添加商品</el-button>
        </el-button-group>
      </h1>
      <div class="header-index-content">
        <p>你也可以在下面选择一些操作</p>
        <p class="content-link">
          <a href="javascript:;">
            <icon name="arrow_downward" />下载数据
          </a>
          <a href="javascript:;">
            <icon name="arrow_upward" />导入数据
          </a>
        </p>
      </div>
    </div>

    <el-form inline :model="query" class="filter-form">
      <el-form-item label="商品名称">
        <el-input v-model="query.name" placeholder="商品名称" />
      </el-form-item>
      <el-form-item label="评论关键字">
        <el-input v-model="commentQuery.content" placeholder="商品名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table class="table block" v-loading="loading" :data="collection">
      <el-table-column prop="name" label="商品名称" />
      <el-table-column prop="price" label="价格" :formatter="$tableHelper.fmts.price" />
      <el-table-column prop="created_at" label="创建日期" :formatter="$tableHelper.fmts.date" />
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('goods')

export default {
  data() {
    return {
      loading: false,
      query: {
        name: '',
      },
      commentQuery: {
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
  },
  methods: {
    async queryCollection({ pagination = {} } = {}) {
      const query = {
        ...this.query,
        name: this.query.name ? `%${this.query.name}%` : undefined // 设为模糊搜索
      }
      const commentQuery = {
        ...this.commentQuery,
        content: this.commentQuery.content ? `%${this.commentQuery.content}%` : undefined  // 设为模糊搜索
      }
      try {
        this.loading = true
        await this.$store.dispatch('goods/collection', { query, relsQuery: { comments: commentQuery }, pagination })
      } finally {
        this.loading = false
      }
    },
    async remove(goods) {
      await this.$confirm('确认要删除此商品？')
      await this.$store.dispatch('goods/remove', goods)
      await this.queryCollection()
      this.$message.success('商品删除操作完成')
    }
  },
  mounted() {
    this.queryCollection()
  },
  activated() {
    this.queryCollection()
  }
}
</script>
